module.exports = __webpack_public_path__ + "assets/img/Penalty.webp?7161919f6f69bfb45e68b306815f6de5";